/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TodoSource {
  Manual = "manual",
  DialpadRecap = "dialpad_recap",
  CarrierMeeting = "carrier_meeting",
  CompanyMeeting = "company_meeting",
}

export function instanceOfTodoSource(value: any): boolean {
  for (const key in TodoSource) {
    if (Object.prototype.hasOwnProperty.call(TodoSource, key)) {
      if (TodoSource[key as keyof typeof TodoSource] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TodoSourceFromJSON(json: any): TodoSource {
  return TodoSourceFromJSONTyped(json, false);
}

export function TodoSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TodoSource {
  return json as TodoSource;
}

export function TodoSourceToJSON(value?: TodoSource | null): any {
  return value as any;
}

export function TodoSourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TodoSource {
  return value as TodoSource;
}
